<template>
  <vis-loading
    size="lg"
    class="ba-h-screen ba-justify-center"
  >Выполняется проверка профиля пользователя…</vis-loading>
</template>

<script>
import log from "@/shared/log";
import parseJson from "@/shared/parse-json";
import navUtils from "@/shared/nav-utils";
import rhmApi from "@/api/rhm-api";
import delay from "@/shared/delay";

const UPDATE_ESIA_DATA_DELAY = 3000;

export default {
  name: "vis-attach-external-callback",
  props: {
    state: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: null
    }
  },
  created() {
    this.attachExternalCallback();
  },
  methods: {
    attachExternalCallback() {
      if (this.error) {
        log.error(`Error attach profile to esia: ${this.error}`);
      }

      this.updateEsiaData(() => {
        this.redirectToRoute(this.state);
      });
    },
    async updateEsiaData(completion = () => {}) {
      try {
        await rhmApi.esia.setEsiaData();
        await delay(UPDATE_ESIA_DATA_DELAY);
        completion();
      } catch (e) {
        log.error(e);
        completion();
      }
    },
    redirectToRoute(state) {
      const route = parseJson(state);

      if (route?.name) {
        if (route?.params?.id) {
          this.$router.push({
            name: route.name,
            params: { id: route.params.id }
          });
        } else {
          this.$router.push({
            name: route.name
          });
        }
      } else {
        navUtils.navigateToHome(this.$router);
      }
    }
  }
};
</script>
